import { createContext } from 'libs/createContext'

export const {
  Provider: SurveySettingProvider,
  Consumer: SurveySettingConsumer,
  withContext: withSurveySettingContext,
  context: surveySettingContext,
} = createContext({
  currentSaveFunction: () => {},
  isSurveyBuilderDirty: false,
  isSubmitting: false,
  isDisabled: false,
  isEmailActionButtonDisable: false,
  isSaveButtonHidden: false,
  /** @type {any[]} */
  deletedVisibility: [],
  /**
   * Set by the survey builder while mounted. `null` = builder not mounted; fall
   * back to a fresh questions fetch. Kept in shared context so the header's
   * flip-choices menu reflects unsaved builder edits (temp questions/choices).
   */
  hasFlippableBuilderQuestion: null,
})



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/SurveySettings/context.js